export default __webpack_public_path__ + "static/media/debate_11.1f536af9.JPG";